module.exports = __webpack_public_path__ + "img/sanhui.4d9ac13d.png";